import React from 'react'
import { useMutation } from 'react-query'
import hooks from '../../../hooks'
import USER_ROLES from '../../../constants/user-roles'

const useCreateUsersMutation = ({
    onSuccess = () => {}
}) => {
    const [ records, setRecords ] = React.useState([])
    const [ users, setUsers ] = React.useState([])
    const [ rolesCode, setRolesCode ] = React.useState(USER_ROLES.STUDENT)

    const { toastSuccess, toastError } = hooks.useToasts({ successMessage: 'Users created!', onSuccess })
    const cacheKeys = hooks.useCacheKeys()
    const { clearCache } = hooks.useCache({ key: cacheKeys.USERS, onReload: toastSuccess })
    const { api, endpoints } = hooks.useApi()

    const [createUsers, { isLoading: isCreatingUsers }] = useMutation(
        () => api.post(endpoints.users, users.map(u => ({ ...u, rolesCode }))),
        {
            onError: toastError,
            onSuccess: clearCache
        }
    )

    return {
        records,
        setRecords,
        users,
        setUsers,
        rolesCode,
        setRolesCode,
        createUsers,
        isCreatingUsers
    }
}

export default useCreateUsersMutation
